import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  publishableKey: "",
  getPublishableKeySuccess: false,
  getPublishableKeyLoading: false,
  getPublishableKeyError: "",

  //create hiring session
  createPurchaseSessionError: null,
  createPurchaseSessionLoading: false,
  createPurchaseSessionSuccess: false,
  purchaseSession: null,
};

const PaymentPurchaseSlice = createSlice({
  name: "Payment Purchase",
  initialState,
  reducers: {
    getPublishableKeyRequest: (state) => {
      state.publishableKey = "";
      state.getPublishableKeyLoading = true;
      state.getPublishableKeySuccess = false;
      state.getPublishableKeyError = "";
    },
    getPublishableKeySuccess: (state, action) => {
      state.publishableKey = action.payload;
      state.getPublishableKeyLoading = false;
      state.getPublishableKeySuccess = true;
      state.getPublishableKeyError = "";
    },
    getPublishableKeyFailure: (state, action) => {
      state.publishableKey = "";
      state.getPublishableKeyLoading = false;
      state.getPublishableKeySuccess = false;
      state.getPublishableKeyError = action.payload;
    },

    //create hiring session
    createPurchaseSessionRequest: (state) => {
      state.createPurchaseSessionError = null;
      state.createPurchaseSessionLoading = true;
      state.createPurchaseSessionSuccess = false;
      state.purchaseSession = null;
    },
    createPurchaseSessionSuccess: (state, action) => {
      state.createPurchaseSessionError = null;
      state.createPurchaseSessionLoading = false;
      state.createPurchaseSessionSuccess = true;
      state.purchaseSession = action.payload;
    },
    createPurchaseSessionFailure: (state, action) => {
      state.createPurchaseSessionError = action.payload;
      state.createPurchaseSessionLoading = false;
      state.createPurchaseSessionSuccess = false;
      state.purchaseSession = null;
    },

    //clear all
    clearAll: (state) => {
      state.getPublishableKeySuccess = false;
      state.getPublishableKeyError = "";

      state.createPurchaseSessionSuccess = false;
      state.createPurchaseSessionError = null;
    },
  },
});
export const PaymentPurchaseActions = PaymentPurchaseSlice.actions;

export default PaymentPurchaseSlice.reducer;
